module.exports = __webpack_public_path__ + "static/media/picture_vladimir_hover.b8fc4522.jpg";